module.exports = {
          srcSet: __webpack_public_path__ + "d11335de8c3ca06ae09fcdda4dc948fa-2336.png"+" 2336w",
          images:[ {path: __webpack_public_path__ + "d11335de8c3ca06ae09fcdda4dc948fa-2336.png",width: 2336,height: 396}],
          src: __webpack_public_path__ + "d11335de8c3ca06ae09fcdda4dc948fa-2336.png",
          toString:function(){return __webpack_public_path__ + "d11335de8c3ca06ae09fcdda4dc948fa-2336.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/ACMiJ/w3Nzz/ODg9/kFCRv85OD3/FB4n/385Lf9xKSP+R0I4/089MfkAGhke/CkpLf8mJiv+LC0y/y8vNP8WICn/ezcr/4A1Mv6wj03/q4gz+R8eIgOXXLNpAAAAAElFTkSuQmCC",
          width: 2336,
          height: 396
        }